// Import the Firebase modules that you need in your app.
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/firestore";

// Initalize and export Firebase.
const firebaseConfig = {
  apiKey: "AIzaSyDCFcRN0x9Bt8U0PIAstJBeaw7lueZd7Jg",
  authDomain: "apc-mobile-a329e.firebaseapp.com",
  databaseURL: "https://apc-mobile-a329e.firebaseio.com",
  projectId: "apc-mobile-a329e",
  storageBucket: "apc-mobile-a329e.appspot.com",
  messagingSenderId: "441158566782",
  appId: "1:441158566782:web:490e042ae31c095463692f",
};

const app = firebase.initializeApp(firebaseConfig);

export default {
  auth: app.auth(),
  firestore: app.firestore(),
};

export const CreateEmailCredential = (email: string, password: string) =>
  firebase.auth.EmailAuthProvider.credential(email, password);
